import type { IAppSettings } from '../appSettings.types';
import { commonAppSettings } from '../commonAppSettings';

const basename = __BASENAME__ ? `/${__BASENAME__}` : '';

export const prodAppSettings: IAppSettings = {
  ...commonAppSettings,
  environment: {
    name: 'prod',
    url: `https://app.crowdaa.com${basename}`,
  },
  enabledRegions: ['crowdaa-us', 'crowdaa-fr'],
  defaultRegion: 'crowdaa-fr',
  analytics: {
    googleTagManager: {
      enabled: true,
      environment: {
        id: 'GTM-PLPTLHXX',
        auth: 'B_YcT1qRkAV2jLjy9WyAwg',
        preview: 'env-1',
      },
    },
    hotjar: {
      enabled: false,
      siteId: '5015493',
    },
    sentry: {
      enabled: true,
      dsn: 'https://dd4d1632fbfc3c21fd4d52cb0fa27202@o4507388908994560.ingest.de.sentry.io/4507388911222864',
    },
  },
  stripe: {
    billingPortalUrl: 'https://billing.stripe.com/p/login/cN2cQa28hcf25UcaEE',
  },
  mapBox: {
    accessToken:
      'pk.eyJ1IjoiY3Iwd2Q0NCIsImEiOiJjbTFvdmV4YWwxN3F5MnFzZzdyeGt2Z2pzIn0.2hFIsABThqKrlhY7rMYdbg',
    styles: {
      light: 'mapbox://styles/cr0wd44/cm1ozmy4y00pj01pi4n2bfbx1',
      dark: 'mapbox://styles/cr0wd44/cm1ovo6co00oz01pi5wp0h8du',
    },
  },
};
